import React, { Component } from 'react';
import style from './style.css';
import CSSModules from 'react-css-modules';
import DropList from '../dropList';
import Button from '../button';
import { Radio } from 'antd';
const RadioGroup = Radio.Group;

class SimpleCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lesson: ''
        }

        this.onSelected = (e) => {
            this.onSelected = (name, value) => {
                this.setState({
                    [name]: value.value
                })
            }
        }

        this.onSubmit = (e) => {
            if(this.checkValid(this.state)) this.props.onSubmit(this.state);
        }
    }

    checkValid(state) {
        return state.lesson.length > 0;
    }

    render(){

        const { studentData, dateData, className } = this.props;

        return (
            <div styleName="cardBlock" className={this.props.className}>
                上課日期
                <DropList 
                    listContent={dateData}
                    onSelected={this.onSelected.bind(this, 'lesson')}
                    width={130}/>
                <Button onClick={this.onSubmit} styleName="button">報名</Button>
            </div>
        );
    }
}
export default CSSModules(SimpleCard,style,{allowMultiple:true});


/** WEBPACK FOOTER **
 ** ./src/component/classBar/simpleCard.js
 **/